import { defineSemanticTokens } from '@chakra-ui/react';
export const semanticTokens = defineSemanticTokens({
    colors: {
        primary: {
            value: '{colors.primary.shockingPink}',
        },
    },
});
